<!--begin:: Portlet-->
<div class="kt-portlet">
    <div class="kt-portlet__body kt-portlet__body--fit">

        <!--begin::Widget -->
        <div class="kt-widget kt-widget--project-1">
            <div class="kt-widget__head">
                <div class="kt-widget__label">
                    <!-- <div class="kt-widget__media">
                            <span class="kt-media kt-media--lg kt-media--circle">
                                <img src="assets/img/bkd_renkli_zeminsiz.png" alt="image">
                            </span>
                        </div> -->
                    <div class="kt-widget__info">
                        <a href="#" class="kt-widget__title">
                            {{event.name}}
                        </a>
                        <span class="kt-widget__desc">
                            {{event.eventCategoryName}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="kt-widget__body">
                <div class="kt-widget__stats">
                    <div class="kt-widget__item">
                        <span class="kt-widget__date">
                            Başlangıç Tarihi
                        </span>
                        <div class="kt-widget__label">
                            <span class="btn btn-label-brand btn-sm btn-bold btn-upper">{{event.startDate}}</span>
                        </div>
                    </div>
                    <div class="kt-widget__item">
                        <span class="kt-widget__date">
                            Bitiş Tarihi
                        </span>
                        <div class="kt-widget__label">
                            <span class="btn btn-label-danger btn-sm btn-bold btn-upper">{{event.endDate}}</span>
                        </div>
                    </div>
                    <!-- <div class="kt-widget__item flex-fill">
                            <span class="kt-widget__date">
                                Mekan / Lokasyon
                            </span>
                            <div class="kt-widget__label">
                                <span style="font-weight: 700;"></span>
                            </div>
                        </div> -->
                </div>
                <span class="kt-widget__text">
                    Mekan / Lokasyon: <strong>{{event.location}}</strong><br><br>
                    {{event.description}}
                </span>
            </div>
        </div>

        <!--end::Widget -->
    </div>
</div>

<!--end:: Portlet-->


<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
                <i class="la la-gear"></i>
            </span>
            <h3 class="kt-portlet__head-title">
                Açık Gönüllü Pozisyonları
            </h3>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-pricing-1">
            <div class="kt-pricing-1__items row">
                <div class="kt-pricing-1__item col-lg-3 col-md-6 col-xs-12" *ngFor="let eventProperty of event.eventProperties">
                    <div class="kt-pricing-1__visual" style="float: left;">
                        <div class="img-fluid">

                            <img src="assets/img/foto1.jpg" *ngIf="eventProperty.volunteerRoleName =='Etkinlik Gönüllüsü'" style="width: 80%; border-radius: 10%;" alt="image">
                            <img src="assets/img/juri.jpg" *ngIf="eventProperty.volunteerRoleName =='Jüri'" style="width: 80%; border-radius: 10%;" alt="image">
                            <img src="assets/img/hakem.jpg" *ngIf="eventProperty.volunteerRoleName =='Hakem'" style="width: 80%; border-radius: 10%;" alt="image">
                        </div>
                        <!-- <div class="kt-pricing-1__hexagon1"></div>
                        <div class="kt-pricing-1__hexagon2"></div>
                        <span class="kt-pricing-1__icon kt-font-success"><i class="fa flaticon-confetti"></i></span> -->
                    </div>
                    <span class="kt-pricing-1__price" style="margin-top: 1rem;">{{eventProperty.volunteerRoleName}} {{eventProperty.isApplied ? "(Başvuruldu)" : ""}}</span>
                    <h2 class="kt-pricing-1__subtitle">{{eventProperty.applicationCount}} / {{eventProperty.maxApplication}}</h2>
                    <span class="kt-pricing-1__description">
                        <span>Rol detayı:</span>
                        <span><strong>{{eventProperty.description}}</strong></span>
                    </span>
                    <span class="kt-pricing-1__description">
                        <span>Son başvuru tarihi:</span>
                        <span><strong>{{eventProperty.applicationEndDate}}</strong></span>
                    </span>
                    <div class="kt-pricing-1__btn">
                        <button type="button"
                            class="btn btn-pill btn-success btn-wide btn-uppercase btn-bolder btn-sm" *ngIf="!eventProperty.isApplied" (click)="applyForEvent(eventProperty.volunteerRoleTypeId)">Başvur</button>
                            <button type="button"
                            class="btn btn-pill  btn-danger btn-wide btn-uppercase btn-bolder btn-sm" *ngIf="eventProperty.isApplied" (click)="cancelApplication(eventProperty.applicationId)">İptal et</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>